import {
  ShiftChangeRequestApprovalStatus,
  ShiftChangeRequestColleagueApprovalStatus,
  ShiftChangeRequestDetailedStatus,
  ShiftChangeRequestFragmentFragment,
} from '../../../__generated__/graphql';

export type SentShiftChangeRequestTableItem = {
  id: string;
  name: string;
  shiftId: string | null;
  shiftTitle: string;
  shiftStartDate: string;
  shiftEndDate: string;
  requestedAt: string;
  requestReason: string | null;
  proposedEmployee: {
    id: string;
    name: string;
  } | null;
  status: ShiftChangeRequestApprovalStatus;
  statusDetailed: ShiftChangeRequestDetailedStatus | null;
  colleagueApprovalStatus: ShiftChangeRequestColleagueApprovalStatus | null;
  colleagueRespondedAt: string | null;
  actions: React.ReactNode;
};

export const mapSentShiftChangeRequests = (
  requests: readonly ShiftChangeRequestFragmentFragment[],
): SentShiftChangeRequestTableItem[] => {
  return requests.map((request) => ({
    id: request.Id,
    name: request.Id,
    shiftId: request.shift?.Id || null,
    shiftTitle: request.shift?.flair__Title__c || '',
    shiftStartDate: request.shift?.flair__Start_Datetime__c || '',
    shiftEndDate: request.shift?.flair__End_Datetime__c || '',
    requestedAt: request.flair__Requested_At__c || '',
    requestReason: request.flair__Change_Reason__c || null,
    proposedEmployee: request.proposedResourceEmployee
      ? {
          id: request.proposedResourceEmployee.Id,
          name: request.proposedResourceEmployee.Name,
        }
      : null,
    status: request.flair__Approval_Status__c,
    statusDetailed: request.flair__Approval_Status_Detailed__c || null,
    colleagueApprovalStatus:
      request.flair__Colleague_Approval_Status__c || null,
    colleagueRespondedAt: request.flair__Colleague_Responded_At__c || null,
    actions: null,
  }));
};
